import { EntityType } from '../../../models/entity-type';
import { FormulaDescriptionComponent } from '../formula-description/formula-description.component';

export interface DescriptionFormDropdownList {
  targetType: { value: string; label: string }[];
  status: { value: string; label: string }[];
};

export const getDescriptionFormDropdowns = (component: FormulaDescriptionComponent) => {
  return {
    targetType: [
      {
        value: 'ALL',
        label: component.translateService.instant('distribution.assessmentTypes.ALL')
      },
      {
        value: EntityType.department,
        label: component.translateService.instant(
          `distribution.assessmentTypes.${EntityType.department}`
        )
      },
      {
        value: EntityType.vendor,
        label: component.translateService.instant(
          `distribution.assessmentTypes.${EntityType.vendor}`
        )
      },
      {
        value: EntityType.site,
        label: component.translateService.instant(
          `distribution.assessmentTypes.${EntityType.site}`
        )
      },
      {
        value: EntityType.resource,
        label: component.translateService.instant(
          `distribution.assessmentTypes.${EntityType.resource}`
        )
      },
      {
        value: EntityType.productAndService,
        label: component.translateService.instant(
          `distribution.assessmentTypes.${EntityType.productAndService}`
        )
      }
    ],
    status: [
      {
        value: 'ACTIVE',
        label: component.translateService.instant('formulaManagement.formulaStatus.ACTIVE')
      },
      {
        value: 'DRAFT',
        label: component.translateService.instant('formulaManagement.formulaStatus.DRAFT')
      }
    ]
  } as DescriptionFormDropdownList;
};